"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opacify = exports.lighten = exports.getRgbColorFromTheme = exports.getHexColorFromTheme = exports.getErrorColorOverride = exports.getDarkerColorFromThemeColors = exports.darken = void 0;
var _chromaJs = _interopRequireDefault(require("chroma-js"));
var _parseCssColor = _interopRequireDefault(require("parse-css-color"));
var _stencilReactThemeDefault = _interopRequireDefault(require("@amzn/stencil-react-theme-default"));
var _ = require("./");
var _utils = require("./utils");
var parseCssColorToChromaColor = function parseCssColorToChromaColor(colorString) {
  var rgbHex = (0, _parseCssColor.default)(colorString);
  var color;
  switch (rgbHex.type) {
    case 'hsl':
      color = (0, _chromaJs.default)(rgbHex.values[0], rgbHex.values[1] / 100, rgbHex.values[2] / 100, rgbHex.type);
      break;
    case 'rgb':
      color = (0, _chromaJs.default)(rgbHex.values[0], rgbHex.values[1], rgbHex.values[2], rgbHex.type);
      break;
    default:
      throw Error("Could not parse color ".concat(colorString));
  }
  return color;
};
var opacify = function opacify(cssColor, amount) {
  try {
    return parseCssColorToChromaColor(cssColor).alpha(amount).css();
  } catch (error) {
    return '#000000';
  }
};
exports.opacify = opacify;
var darken = function darken(cssColor, amount) {
  var value = 1 - (amount < 0 ? 0 : amount > 1 ? 1 : amount);
  var darkenRgbChannel = function darkenRgbChannel(currentValue) {
    return currentValue * value;
  };
  try {
    var inputColor = parseCssColorToChromaColor(cssColor);
    return inputColor.set('rgb.r', darkenRgbChannel(inputColor.get('rgb.r'))).set('rgb.g', darkenRgbChannel(inputColor.get('rgb.g'))).set('rgb.b', darkenRgbChannel(inputColor.get('rgb.b'))).hex();
  } catch (_unused) {
    return '#000000';
  }
};
exports.darken = darken;
var lighten = function lighten(cssColor, amount) {
  var value = amount < 0 ? 0 : amount > 1 ? 1 : amount;
  var lightenRgbChannel = function lightenRgbChannel(currentValue) {
    return currentValue + (255 - currentValue) * value;
  };
  try {
    var inputColor = parseCssColorToChromaColor(cssColor);
    return inputColor.set('rgb.r', lightenRgbChannel(inputColor.get('rgb.r'))).set('rgb.g', lightenRgbChannel(inputColor.get('rgb.g'))).set('rgb.b', lightenRgbChannel(inputColor.get('rgb.b'))).hex();
  } catch (_unused2) {
    return '#000000';
  }
};
exports.lighten = lighten;
var getDarkerColorFromThemeColors = function getDarkerColorFromThemeColors(themeColors, color) {
  var colorGrades = color.match(/\d+/);
  var defaultValue = (0, _utils.getValueOrNull)(themeColors, color);
  if (!colorGrades) {
    return defaultValue;
  }
  var colorGrade = parseInt(colorGrades[0]);
  var colorBase = color.replace("".concat(colorGrade), '');
  var minorColorGrade = "".concat(colorGrade + 5);
  var minorHoverColor = (0, _utils.getValueOrNull)(themeColors, "".concat(colorBase).concat(minorColorGrade.length === 1 ? "0".concat(minorColorGrade) : minorColorGrade));
  return minorHoverColor || (0, _utils.getValueOrNull)(themeColors, "".concat(colorBase).concat(colorGrade + 10)) || defaultValue;
};
exports.getDarkerColorFromThemeColors = getDarkerColorFromThemeColors;
var getErrorColorOverride = function getErrorColorOverride(error, warning) {
  if (error) {
    return _.LABEL_ERROR_COLOR;
  }
  if (warning) {
    return _.LABEL_WARNING_COLOR;
  }
  return undefined;
};
exports.getErrorColorOverride = getErrorColorOverride;
var getHexColorFromTheme = function getHexColorFromTheme(color) {
  return _stencilReactThemeDefault.default.color[color];
};
exports.getHexColorFromTheme = getHexColorFromTheme;
var getRgbColorFromTheme = function getRgbColorFromTheme(color) {
  var hexColor = _stencilReactThemeDefault.default.color[color]; // Chroma returns the color in the format "rgb(X,X,X)", in CSS it's rendered
  // as "rgb(X, X, X)" (note the spaces)

  return (0, _chromaJs.default)(hexColor).css().replace(/,/g, ', ');
};
exports.getRgbColorFromTheme = getRgbColorFromTheme;